import { Component } from '@angular/core';
import { KENDO_GRIDLAYOUT } from '@progress/kendo-angular-layout';
import { PageContainerComponent } from '@unity/components/layouts/page-container/page-container.component';
import { GridUserInternalSharedComponent } from '@unity/components/shared/grid-user-internal-shared/grid-user-internal-shared.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-user-page',
  standalone: true,
  styleUrl: './list-user-page.component.scss',
  templateUrl: './list-user-page.component.html',
  imports: [KENDO_GRIDLAYOUT, PageContainerComponent, GridUserInternalSharedComponent, ActionSharedComponent],
})
export class ListUserPageComponent {
  protected createUserAction = QuickActions.CreateUser();
  protected createInternalUserAction = QuickActions.CreateInternalUser();
  protected returnToDashboardAction = QuickActions.ReturnToDashboard;
}
